import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const WarningIcon = (props: IIconProps) => {
  const { width = 38, height = 37, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 15.0312V20.8125" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.0037 5.78162L4.28492 27.7504C4.0823 28.1013 3.97546 28.4993 3.9751 28.9046C3.97474 29.3098 4.08088 29.708 4.28288 30.0593C4.48488 30.4106 4.77565 30.7027 5.12606 30.9062C5.47647 31.1098 5.87422 31.2177 6.27945 31.2191H31.717C32.1222 31.2177 32.5199 31.1098 32.8703 30.9062C33.2208 30.7027 33.5115 30.4106 33.7135 30.0593C33.9155 29.708 34.0217 29.3098 34.0213 28.9046C34.0209 28.4993 33.9141 28.1013 33.7115 27.7504L20.9927 5.78162C20.7916 5.43021 20.5013 5.13818 20.151 4.93507C19.8008 4.73197 19.4031 4.625 18.9982 4.625C18.5933 4.625 18.1956 4.73197 17.8454 4.93507C17.4951 5.13818 17.2048 5.43021 17.0037 5.78162V5.78162Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19 27.75C19.9579 27.75 20.7344 26.9735 20.7344 26.0156C20.7344 25.0578 19.9579 24.2812 19 24.2812C18.0421 24.2812 17.2656 25.0578 17.2656 26.0156C17.2656 26.9735 18.0421 27.75 19 27.75Z" fill={color} />
    </svg>
  );
};

export default memo(WarningIcon);
